import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { OccupationalDoctorService } from '@/infra/services/occupational-doctor';

interface GetListOccupationalDoctorParams {
	organization_id: string;
	company_id: string;
	name?: string;
	offset?: number;
	limit?: number;
}

const Service = OccupationalDoctorService.getInstance();

export const useGetListOccupationalDoctor = (params: GetListOccupationalDoctorParams) => {
	const isEnabled = validateUuid([params.company_id, params.organization_id]);
	return useQuery({
		queryKey: [QUERY_KEYS.GET_LIST_OCCUPATIONAL_DOCTOR, params],
		queryFn: async () => Service.index(params),
		enabled: isEnabled
	});
};
